<script setup lang="ts">
import { computed } from 'vue';
import { IDepartment } from '@/interfaces';
import { useDepartmentStore } from '@/stores/department';

const departmentStore = useDepartmentStore();

interface Props {
  selectedDepartment?: IDepartment;
  departments?: IDepartment[];
  isOpen?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
});

const emit = defineEmits(['close']);

const department = computed(() => {
  return props.selectedDepartment || departmentStore;
});

const onClickoutside = () => {
  if (!props.isOpen) return;
  emit('close');
};
</script>

<template>
  <div class="departmentSwitcherContainer flex justify-center pb-8">
    <div
      v-if="isOpen"
      class="fixed inset-0 backdrop z-[70]"
      @click.stop="emit('close')"
    />

    <div
      class="relative"
      v-clickoutside="{
        excludeString: '.options, .options>*, .selection, .selection>*',
        handler: onClickoutside,
      }"
    >
      <div class="bg-neutral-0 wrapper rounded-full h-[64px]">
        <div
          class="w-[445px] flex selection items-center justify-between z-75 px-4 rounded-full h-full"
        >
          <div
            class="flex items-center justify-center rounded-full"
            :style="{
              backgroundColor: department.color,
              height: '40px',
              width: '40px',
            }"
          >
            <fa-icon class="text-xl text-white" :icon="['fas', 'home']" />
          </div>

          <p class="h400">
            {{ department.name }}
          </p>

          <div class="items-center">
            <fa-icon
              class="text-lg"
              :icon="['far', isOpen ? 'chevron-up' : 'chevron-down']"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.backdrop {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
}
.departmentSwitcherContainer {
  .wrapper {
    box-shadow: 0 0 11.2px 0 rgba(0, 0, 0, 0.15);
  }

  .options {
    .option {
      height: 96px;
    }
  }
}
</style>
